var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"default-banner"},[_c('p',[_vm._v(_vm._s(_vm.text))]),(!_vm.status)?_c('i',{staticClass:"iconfont icon-logo1",style:({ fontSize: _vm.fontSize })}):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }